import { MapPin } from "lucide-react";
import Reveal from "./Reveal";
import { NEARBY, DISTANCES, CONTACT } from "@/data/content";

export default function Location() {
    const mapSrc =
        "https://www.google.com/maps?q=Borkumer+Stra%C3%9Fe+29a,+26871+Papenburg,+Germany&z=14&output=embed";

    return (
        <section
            id="lage"
            data-testid="location-section"
            className="section-y relative"
        >
            <div className="container-em">
                <div className="max-w-3xl">
                    <Reveal>
                        <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                            Lage
                        </span>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2
                            data-testid="location-title"
                            className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-tight tracking-tight text-balance"
                        >
                            Mittendrin. Und ruhig.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 text-foreground/70 text-lg leading-relaxed max-w-2xl">
                            Zentral in Papenburg gelegen – die Meyer Werft, die
                            Innenstadt und Ausflugsziele im Emsland sind in
                            wenigen Minuten erreichbar.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 max-w-3xl">
                            {DISTANCES.map((d) => (
                                <div
                                    key={d.label}
                                    data-testid="distance-card"
                                    className="rounded-2xl border border-border/60 bg-card px-5 py-4"
                                >
                                    <p className="font-accent text-[10px] uppercase tracking-[0.28em] text-foreground/55">
                                        {d.label}
                                    </p>
                                    <p className="mt-1.5 font-display text-2xl leading-none text-foreground">
                                        {d.value}
                                    </p>
                                    <p className="mt-1 text-xs text-foreground/60">
                                        {d.note}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>

                <div className="mt-14 grid lg:grid-cols-12 gap-8 md:gap-10 items-start">
                    <Reveal className="lg:col-span-8">
                        <div className="overflow-hidden rounded-3xl border border-border/60 aspect-[16/11] lg:aspect-[16/10] shadow-[0_20px_60px_-24px_rgba(60,60,50,0.25)]">
                            <iframe
                                title="Karte – Emsglück, Borkumer Straße 29a, Papenburg"
                                src={mapSrc}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                className="w-full h-full border-0"
                                data-testid="location-map"
                            />
                        </div>
                    </Reveal>

                    <div className="lg:col-span-4">
                        <Reveal>
                            <div className="rounded-3xl bg-card border border-border/60 p-8">
                                <div className="flex items-start gap-3">
                                    <div className="mt-1 w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
                                        <MapPin size={18} strokeWidth={1.7} />
                                    </div>
                                    <div>
                                        <p className="font-accent text-xs uppercase tracking-[0.25em] text-foreground/60">
                                            Adresse
                                        </p>
                                        <p
                                            className="mt-2 font-display text-2xl leading-snug text-foreground"
                                            data-testid="location-address"
                                        >
                                            Borkumer Straße 29a
                                            <br />
                                            26871 Papenburg
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>

                        <Reveal delay={0.08}>
                            <div className="mt-6 rounded-3xl bg-muted/60 border border-border/60 p-8">
                                <p className="font-accent text-xs uppercase tracking-[0.25em] text-foreground/60">
                                    In der Nähe
                                </p>
                                <ul className="mt-4 grid grid-cols-1 gap-3">
                                    {NEARBY.map((n) => (
                                        <li
                                            key={n.name}
                                            data-testid="location-nearby-item"
                                            className="flex items-start gap-3 text-foreground/85"
                                        >
                                            <span
                                                aria-hidden
                                                className="mt-2 h-1.5 w-1.5 rounded-full bg-primary shrink-0"
                                            />
                                            <div>
                                                <p className="text-foreground/85">
                                                    {n.name}
                                                </p>
                                                <p className="text-xs text-foreground/55">
                                                    {n.meta}
                                                </p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Reveal>

                        <Reveal delay={0.12}>
                            <a
                                href="#anfrage"
                                data-testid="location-inquiry-button"
                                className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:bg-primary/90 transition-all duration-300 hover:-translate-y-0.5"
                            >
                                Jetzt unverbindlich anfragen
                            </a>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
